import { List, Map } from 'immutable';

import createTypedReducer from '../createTypedReducer';
import * as adminActions from './action';
import { CLEAR } from '../authentication/action';

export const initialState = Map({
  admin: Map(),
});

function resetState (state) {
  return state.withMutations((nextState) =>
    nextState
      .set('admin', Map())
  );
}

export const adminReducer = createTypedReducer(initialState, {

  [adminActions.FETCH_CLIENTS_SUCCESS] (state, action) {
    return state.withMutations((nextState) =>
      nextState.setIn(['admin', 'clients'], action.clients)
    );
  },
  [adminActions.FETCH_CLIENTS_FOR_MANAGER] (state, action) {
    return state.withMutations((nextState) =>
      nextState.setIn(['admin', 'clientsForManager'], List())
    );
  },
  [adminActions.FETCH_CLIENTS_FOR_MANAGER_SUCCESS] (state, action) {
    console.log(action.clientsForManager);
    return state.withMutations((nextState) =>
      nextState.setIn(['admin', 'clientsForManager'], action.clientsForManager)
    );
  },

  [adminActions.FETCH_CLIENTS_FOR_MANAGER_FAILED] (state, action) {
    return state.withMutations((nextState) =>
      nextState.setIn(['admin', 'clientsForManager'], List())
    );
  },

  [adminActions.FETCH_TIERS_SUCCESS] (state, action) {
    return state.withMutations((nextState) =>
      nextState.setIn(['admin', 'tiers'], action.tiers)
    );
  },

  [adminActions.UPDATE_CLIENT_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const clientsPath = ['admin', 'clients'];
      const clientsForManagerPath = ['admin', 'clientsForManager'];

      // Ensure clients list exists
      if (!List.isList(nextState.getIn(clientsPath))) {
        nextState.setIn(clientsPath, List());
      }

      // Ensure clientsForManager list exists
      if (!List.isList(nextState.getIn(clientsForManagerPath))) {
        nextState.setIn(clientsForManagerPath, List());
      }

      const clients: any = nextState.getIn(clientsPath);
      const clientIndex = clients.findIndex(
        (item) => item.get('id') === action.client.get('id')
      );

      if (clientIndex !== -1) {
        nextState.setIn([...clientsPath, clientIndex], action.client);
      } else {
        nextState.updateIn(clientsPath, (list) => list.push(action.client));
      }

      // Also update clientsForManager list
      const clientsForManager: any = nextState.getIn(clientsForManagerPath);
      const clientForManagerIndex = clientsForManager.findIndex(
        (item) => item.get('id') === action.client.get('id')
      );

      if (clientForManagerIndex !== -1) {
        nextState.setIn([...clientsForManagerPath, clientForManagerIndex], action.client);
      } else {
        nextState.updateIn(clientsForManagerPath, (list) => list.push(action.client));
      }
    });
  },

  [adminActions.UPDATE_CLIENT] (state, action) {
    return state.withMutations((nextState) => {
      const clientsPath = ['admin', 'clients'];
      const clientsForManagerPath = ['admin', 'clientsForManager'];

      // Ensure lists exist
      if (!List.isList(nextState.getIn(clientsPath))) {
        nextState.setIn(clientsPath, List());
      }
      if (!List.isList(nextState.getIn(clientsForManagerPath))) {
        nextState.setIn(clientsForManagerPath, List());
      }

      // Update clients list
      const clients: any = nextState.getIn(clientsPath);
      const clientIndex = clients.findIndex((item) => item.get('id') === action.clientId);

      if (clientIndex !== -1) {
        // If client is found, merge with the current map and update it at the found index
        nextState.updateIn([...clientsPath, clientIndex], (currentMap) =>
          currentMap.merge(action.clientRec)
        );
      }

      // Also update clientsForManager list
      const clientsForManager: any = nextState.getIn(clientsForManagerPath);
      const clientForManagerIndex = clientsForManager.findIndex((item) => item.get('id') === action.clientId);

      if (clientForManagerIndex !== -1) {
        nextState.updateIn([...clientsForManagerPath, clientForManagerIndex], (currentMap) =>
          currentMap.merge(action.clientRec)
        );
      }
    });
  },

  [CLEAR] (state) {
    return resetState(state);
  },
});
export default adminReducer;
